import Loader from "./Loader";
import { getWindowHeight, getWindowWidth } from "./ElementsUtil";
import openErrorModal from "../Error/ErrorModal";


export default class PrintHandler {
	htmlPDF: string;

	constructor(htmlPDF: string) {
		this.htmlPDF = htmlPDF;
	}

	public print(pdf = this.htmlPDF) {
		Loader.show();
		const width = getWindowWidth();
		const height = getWindowHeight();

		try {
			const mywindow = window.open('', 'PRINT', `
									height=${height * 0.75},
									width=${width * 0.55},
									top=${height * 0.2},
									left=${width * 0.2}`);

			mywindow.document.write(pdf);
			mywindow.document.close();
			mywindow.focus();
		} catch {
			const popupError: string = document.querySelector<HTMLElement>("nav").dataset.popuperror;
			openErrorModal(popupError, null, null, null, "auto");
		}

		Loader.hide();
	}
}
